import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './education.json';

const Education = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Education systems, learning methods, and academic vocabulary. B2/C1 level grammar, reading, and discussion exercises."
            level="B2"
            title="Education"
            image="/Images/education1.webp"
            seoTitle="Free English Lesson Plans: Education"
            seoDescription="Education systems, learning methods, and academic vocabulary. B2/C1 level grammar, reading, and discussion exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Education;


